export default "__VITE_ASSET__jsWatwdT__"